import React from 'react'
import { Link } from 'react-router-dom'

const footer = () => {
  return (
    <footer>
      <Link to='/friends'>
        <button>
          <i className="fas fa-users"></i>
        </button>
      </Link>
      <Link to='/'>
        <button>
          <i className="fas fa-home"></i>
        </button>
      </Link>
      <Link to='/profile'>
        <button>
          <i className="fas fa-list-alt"></i>
        </button>
      </Link>
      <Link to='/settings'>
        <button>
          <i className="fas fa-cog"></i>
        </button>
      </Link>
    </footer>
  )
}

export default footer